class ExpressionEvaluatorService {
  evaluate(tokens, variables = {}) {
    return tokens.reduce((stack, token) => {
      if (ExpressionEvaluatorService.isOperator(token)) {
        this._applyOperator(token, stack);
      } else {
        let value;

        if (Object.prototype.hasOwnProperty.call(variables, token)) {
          value = Number(variables[token]);
        } else if (!isNaN(Number(token))) {
          value = Number(token);
        } else {
          throw new Error(`Unknown token: ${token}`);
        }

        stack.push(value);
      }
      return stack;
    }, [])[0];
  }

  static isOperator(token) {
    return new Set([
      '+',
      '-',
      '*',
      '/',
      '>',
      '<',
      '>=',
      '<=',
      '==',
      '!=',
      'if',
      'DUP',
      'SWAP',
    ]).has(token);
  }

  /* eslint-disable class-methods-use-this */
  _applyOperator(op, stack) {
    const pop = () => stack.pop();
    const push = v => stack.push(v);

    switch (op) {
      case '+':
        push(pop() + pop());
        break;
      case '*':
        push(pop() * pop());
        break;
      case '-': {
        const b = pop();
        const a = pop();
        push(a - b);
        break;
      }
      case '/': {
        const b = pop();
        const a = pop();
        push(Math.trunc(a / b));
        break;
      }
      case '>':
      case '<':
      case '>=':
      case '<=':
      case '==':
      case '!=': {
        const b = pop();
        const a = pop();
        push(ExpressionEvaluatorService.compare(a, b, op) ? 1 : 0);
        break;
      }
      case 'if': {
        const elseVal = pop();
        const thenVal = pop();
        const cond = pop();
        push(cond ? thenVal : elseVal);
        break;
      }
      case 'DUP':
        push(stack[stack.length - 1]);
        break;
      case 'SWAP': {
        const b = pop();
        const a = pop();
        push(b);
        push(a);
        break;
      }
      default:
        throw new Error(`Unsupported operator: ${op}`);
    }
  }

  static compare(a, b, op) {
    switch (op) {
      case '>':
        return a > b;
      case '<':
        return a < b;
      case '>=':
        return a >= b;
      case '<=':
        return a <= b;
      case '==':
        return a === b;
      case '!=':
        return a !== b;
      default:
        throw new Error(`Unsupported comparison: ${op}`);
    }
  }
}

export default ExpressionEvaluatorService;



// WEBPACK FOOTER //
// ./src/utils/expression-evaluator.js